import React from 'react';
import Alert from '../../components/Alert';

const { id: module_id } = module;

export const HpaAccessDenied = () => {
  console.log(module_id);
  return (
    <Alert
      className={'text-center'}
      isHtml={true}
      message={`${module_id}.hpa.access.denied`}
    />
  );
};
